import { UrlMatchResult, UrlSegment } from '@angular/router';

export function familyMatcher (segments: UrlSegment[]): UrlMatchResult {
  if (segments.length === 1 && segments[0].path === 'family') {
    return { consumed: segments, posParams: {} };
  }

  return <UrlMatchResult>(null as any);
}
